import React, {Component} from 'react';
import { withRouter } from 'react-router-dom'

import { GoogleMap, Marker, InfoWindow, withGoogleMap, withScriptjs } from "react-google-maps"
import { MarkerWithLabel } from "react-google-maps/lib/components/addons/MarkerWithLabel";

import Geocode from "react-geocode";

import { Link, Button } from "../util/Clickable";
import { PathGenerator } from "../../constants/path";
import { settings } from "../../assets/settings";

Geocode.setApiKey(process.env.REACT_APP_GOOGLE_KEY);

declare var google;

class GmapCom extends Component {

  state = {
    isOpen: null
  }

  onToggleOpen = (id) => {
    this.setState({
      isOpen: id
    });
  }

  render = () => {
    console.log(settings.map_zoom);
    return (
      <GoogleMap
        defaultZoom={+settings.map_zoom}
        defaultCenter={this.props.center}
      >
        {
          this.props.facilities.map( (facility, index) => {
            return (
              <div key={index}>
                <Marker
                  key={+settings.map_zoom}
                  position={facility.location}
                  onClick={() => this.onToggleOpen(facility.id)}
                >
                  {
                    (this.state.isOpen == facility.id) && (
                      <InfoWindow onCloseClick={() => this.onToggleOpen(null)}>
                        <div className="uk-map-label">
                          <h5 className="uk-margin-xsmall">
                            { facility.name }
                          </h5>
                          <p className="uk-margin-xsmall">
                            { facility.address }
                          </p>
                          <div className="uk-margin-xsmall uk-text-right">
                            <Link to={PathGenerator.facility(facility.id)+this.props.location.search} className="uk-button uk-button-small uk-button-secondary">
                              詳細を見る  
                            </Link>
                          </div>
                        </div>
                      </InfoWindow>
                    )
                  }
                </Marker>
              </div>
            );
          })
        }
      </GoogleMap>
    );
  }
}

const GMap = withScriptjs(withGoogleMap(withRouter(GmapCom)));

class WidthMap extends Component {

  state = {
    facilities: null,
    center: null
  }

  componentDidMount = () => {
    this.geoCode( this.props.facilities );
  }
  componentWillReceiveProps = (nextProps) => {
    this.geoCode(nextProps.facilities);
  }

  geoCode = (facilities) => {
    if(facilities == null){
      return;
    }
    var center = {
      lat: 0, lng: 0
    };
    let promises = facilities.map( (facility) => {
      if(facility.address != null && facility.address.length > 0){
        return Geocode.fromAddress(facility.address).then(
          response => {
            facility.location = response.results[0].geometry.location;
            center.lat += facility.location.lat;
            center.lng += facility.location.lng;
            return facility;
          },
          error => {
            console.error(error);
          }
        );  
      }   
    });
    Promise.all(promises).then( (facilities) => {
      if( facilities.length == 0 ){
        return;
      }
      var founded = facilities.filter( (facility) => {
        return facility != null;
      });
      center.lat /= founded.length;
      center.lng /= founded.length;
      this.setState({
        facilities: founded,
        center: center
      })
    });
  }

  render = () => {
    if( !this.state.center ){ 
      return (
        <div className="uk-text-center">
          <span data-uk-spinner="ratio: 3"></span>
        </div>
      );
    }
    return (
      <GMap 
        googleMapURL={"https://maps.googleapis.com/maps/api/js?key="+process.env.REACT_APP_GOOGLE_KEY+"&v=3.exp&libraries=geometry,drawing,places"}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `500px` }} />}
        mapElement={<div style={{ height: `100%` }} />}
        center={this.state.center}
        facilities={this.props.facilities}
      />
    );
  }
}

export default WidthMap;